module.exports = __webpack_public_path__ + "static/img/8.af77ede.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/zh/8.png
// module id = H+qM
// module chunks = 0